import React from 'react';
import { getActivationCopy } from '../utils/activationCopy';
import '../styles/CardActivationExperience.css';

export default function CardActivationPanel({
  channel,
  isLoggedIn = false,
  isActivating = false,
  isChecking = false,
  userHasCard = false,
  error = '',
  onActivate
}) {
  const copy = getActivationCopy({
    channel,
    isLoggedIn,
    isActivating,
    isChecking
  });

  const busy = isActivating || isChecking;

  if (userHasCard) {
    return (
      <div className="velox-activation-shell">
        <p className="velox-activation-wordmark">VELOX</p>
        <h1 className="velox-activation-title">Card not added</h1>
        <p className="velox-activation-subtitle">
          This card could not be added to your account.
        </p>
        <a className="velox-activation-link velox-activation-link--block" href="mailto:support@velox-network.com">
          Contact support
        </a>
      </div>
    );
  }

  return (
    <div className="velox-activation-shell">
      <p className="velox-activation-wordmark">VELOX</p>
      <h1 className="velox-activation-title">{copy.title}</h1>
      <p className="velox-activation-subtitle">{copy.subtitle}</p>

      <button
        type="button"
        className="velox-activation-cta"
        onClick={onActivate}
        disabled={busy}
      >
        {busy && <span className="velox-activation-cta__spinner" aria-hidden="true" />}
        {copy.cta}
      </button>

      {error && (
        <p className="velox-activation-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
